import React, { useState } from 'react'
import swal from 'sweetalert'
import PostVenta from '../../pages/ReportsPages/PostVenta/PostVenta'
import {
  getSpareParts,
  sendMessage,
  getSparePartsFiltered,
} from '../../services/postVentaServices'
import { swalMessages } from '../../constants'

const PostVentaContainer = () => {
  const [spareParts, setSpareParts] = useState([])
  const [sparePartsFiltered, setSparePartsFiltered] = useState(null)

  const [inputSearch, setInputSearch] = useState({ send: '', search: '' })
  const [saveCSA, setSaveCSA] = useState('')

  const onSubmitSearch = async (e) => {
    e.preventDefault()
    const { search } = inputSearch
    const { success, data } = await getSpareParts({
      csa: search,
    })
    if (success && data.length > 0) {
      setSpareParts(data)
      setSaveCSA(search)
    } else {
      swal(swalMessages.NOT_FOUND)
      setSpareParts([])
    }
  }

  const onSubmitEmail = async (e) => {
    e.preventDefault()
    const { send } = inputSearch
    const { success } = await sendMessage({
      csa: saveCSA,
      correo: send,
    })
    if (success) {
      swal(swalMessages.SUCCESSFUL_EMAIL)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const onChangeInput = (value, field) => {
    setInputSearch({ ...inputSearch, [field]: value })
  }

  const getRepuestosFiltered = async (e) => {
    e.preventDefault()
    const { searchs } = inputSearch

    const { success, data } = await getSparePartsFiltered(searchs)
    if (success && data.length > 0) {
      setSparePartsFiltered(data)
    } else {
      swal(swalMessages.NOT_FOUND)
      setSparePartsFiltered([])
    }
  }

  return (
    <>
      <PostVenta
        spareParts={spareParts}
        sparePartsFiltered={sparePartsFiltered}
        inputSearch={inputSearch}
        onChangeInput={onChangeInput}
        onSubmitEmail={onSubmitEmail}
        onSubmitSearch={onSubmitSearch}
        onSubmitfiltered={getRepuestosFiltered}
      />
    </>
  )
}

export default PostVentaContainer
